import themeReducer from './themeReducer';
import sidebarReducer from './sidebarReducer';
import appsReducer from './appsReducer';
import userReducer from './userReducer';
import reportingReducer from './reportingReducer';
import mediaReducer from './mediaReducer';

export {
  themeReducer,
  sidebarReducer,
  appsReducer,
  userReducer,
  reportingReducer,
  mediaReducer
};



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js